module.exports = __webpack_public_path__ + "static/media/onlyvert.9c63917f.png";